import React, { FC } from "react";
import { Controller, Control, UseFieldArrayRemove } from "react-hook-form";
import RemoveItem from "app/components/common/buttons/RemoveItem";
import InputField from "app/components/common/inputs/InputField";
import FormGroup from "app/components/common/inputs/FormGroup";
import ErrorsMessage from "app/components/common/errors/ErrorsMessage";
import { holdersOptions } from "app/utils/staticValues";
import SelectField from "app/components/common/inputs/SelectField";
import RadioButton from "app/components/common/buttons/RadioButton";

interface FieldItem {
  id: string;
  dbId?: string;
}
interface Props {
  control: Control<any>;
  errors: any;
  fields: FieldItem[];
  deleteItem: any;
  carLoan: string;
  remove: UseFieldArrayRemove;
  applicantID: string;
  deleteIsPending?: boolean;
}

const DynamicJointCarLaon: FC<Props> = ({
  control,
  errors,
  fields,
  carLoan,
  deleteItem,
  applicantID,
  remove,
  deleteIsPending = false,
}) => {
  const getErrorMessage = (fieldName: string) => {
    const fieldNames = fieldName.split(".");
    return fieldNames.reduce((acc, key) => acc && acc[key], errors);
  };
  return (
    <>
      {fields.map((field, index) => {
        const basePath = `${carLoan}.${index}`;
        return (
          <>
            <React.Fragment key={field.id}>
              <FormGroup className="relative">
                <InputField
                  label={`lender’s name`}
                  name={`${basePath}.lenderName`}
                  control={control}
                  type="text"
                  required={true}
                  placeholder="Marvin McKinney"
                  error={
                    getErrorMessage(`${basePath}.lenderName`)?.message as string
                  }
                  className="flex-1"
                />
                <InputField
                  label={`Balance owing`}
                  name={`${basePath}.balanceOwing`}
                  control={control}
                  type="number"
                  required={true}
                  placeholder="$8,000"
                  error={
                    getErrorMessage(`${basePath}.balanceOwing`)
                      ?.message as string
                  }
                  className="flex-1"
                  rules={{
                    min: {
                      value: 1,
                      message: "value must be greater than 0",
                    },
                  }}
                />
                {index > 0 && (
                  <RemoveItem
                    className="absolute right-0"
                    disabled={deleteIsPending}
                    onClick={() => {
                      if (field?.dbId) {
                        deleteItem(
                          `/asset-liability/${applicantID}/carloan/${field?.dbId}`,
                          {
                            onSuccess: () => {
                              remove(index);
                            },
                          }
                        );
                      } else {
                        remove(index);
                      }
                    }}
                  />
                )}
              </FormGroup>
              <FormGroup>
                <InputField
                  label={`Min. monthly payment`}
                  name={`${basePath}.minMonthlyPayment`}
                  control={control}
                  type="number"
                  required={true}
                  placeholder="$446.61"
                  error={
                    getErrorMessage(`${basePath}.minMonthlyPayment`)
                      ?.message as string
                  }
                  className="flex-1"
                  rules={{
                    min: {
                      value: 1,
                      message: "value must be greater than 0",
                    },
                  }}
                />
                <SelectField
                  label="No. of title holders"
                  name={`${basePath}.noOfTitleHolders`}
                  control={control}
                  options={holdersOptions}
                  placeholder="2"
                  error={
                    getErrorMessage(`${basePath}.noOfTitleHolders`)
                      ?.message as string
                  }
                  required={true}
                  className="flex-1"
                />
              </FormGroup>
              <FormGroup>
                <div className="text-left flex-1">
                  <h6 className="font-Mulish text-nowrap text-base text-[#585C7B] mb-4">
                    To be refinanced?
                  </h6>
                  <div className="flex gap-5">
                    <Controller
                      name={`${basePath}.toBeRefinanced`}
                      control={control}
                      render={({ field }) => (
                        <div className="flex gap-5">
                          <RadioButton
                            id={`${basePath}_toBeRefinanced_yes_${index}`}
                            label="Yes"
                            value={true}
                            checked={field.value === true}
                            onChange={() => field.onChange(true)}
                          />
                          <RadioButton
                            id={`${basePath}_toBeRefinanced_no_${index}`}
                            label="No"
                            value={false}
                            checked={field.value === false}
                            onChange={() => field.onChange(false)}
                          />
                        </div>
                      )}
                    />
                  </div>

                  <ErrorsMessage
                    title={
                      getErrorMessage(`${basePath}.toBeRefinanced`)
                        ?.message as string
                    }
                    className="!text-left"
                  />
                </div>
              </FormGroup>
            </React.Fragment>
          </>
        );
      })}
    </>
  );
};

export default DynamicJointCarLaon;
